export default __webpack_public_path__ + "static/realWorldImg3-e2064f0a4d9de02b262a2f198a99dcb3.webp";